function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#1D998C",
  fillRule: "nonzero",
  d: "M128.353 57.396c-.813 8.142 5.098 15.419 13.234 16.302V92.15a23.624 23.624 0 01-11.81 20.453 23.61 23.61 0 01-23.619 0 23.613 23.613 0 01-11.81-20.453V65.872a33.968 33.968 0 0022.167-10.829 33.956 33.956 0 008.978-22.978V8.007H111.77V.327h-5.904v21.26h5.904v-7.675h7.97v18.152c-.692 9.515-6.17 19.026-14.543 23.593a28.051 28.051 0 01-26.865 0C69.958 51.09 64.485 41.58 63.793 32.064V13.912h7.97v7.675h5.904V.327h-5.905v7.675l-14.023.005v24.058a33.96 33.96 0 0030.705 33.809V92.15a29.528 29.528 0 0014.762 25.568 29.54 29.54 0 0029.524 0 29.53 29.53 0 0014.762-25.568V73.7c8.136-.882 14.041-8.16 13.234-16.302-.813-8.142-8.039-14.11-16.187-13.372-8.153-.74-15.372 5.229-16.186 13.371zm7.866 5.132a9 9 0 011.955-9.814 9.001 9.001 0 0115.367 6.366c0 4.977-4.03 9.007-9.002 9.007a9.011 9.011 0 01-8.32-5.559z"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#1D998C",
  strokeWidth: 5.222
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M51.74 29v5.222h17.408V123H3V34.222h19.148V29h29.593z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.148 29h29.593v13.926H22.148z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#1D998C",
  fillRule: "nonzero",
  d: "M19.566 75.42l-4.381 4.061 14.312 13.926 29.207-29.012-4.089-4.062-25.118 24.951z"
}));

var SvgCheckup = function SvgCheckup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 126,
    viewBox: "0 0 161 126"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/checkup.2c812e6a.svg";
export { SvgCheckup as ReactComponent };